// @flow
import {
  UPDATE_DASHBOARD_GRID,
  UPDATE_DASHBOARD_STATUS
} from '../../actions/grid'
import type {
  UPDATE_DASHBOARD_GRID_TYPE,
  UPDATE_DASHBOARD_STATUS_TYPE
} from '../../actions/grid'

type State = {
  isUpdated: boolean,
  layouts: {
    lg: Object[],
    md: Object[],
    sm: Object[],
    xs: Object[]
  },
  isFetching: boolean,
  error: null | string
}

const initialState: State = {
  isUpdated: false,
  layouts: {
    lg: [
      { i: 'a', x: 0, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'b', x: 8, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'c', x: 16, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'd', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'e', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'f', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'g', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'h', x: 0, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'i', x: 8, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'j', x: 16, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'k', x: 0, y: 6, w: 24, h: 7, minH: 7 },
      { i: 'l', x: 0, y: 6, w: 24, h: 12, minH: 12 },
      { i: 'm', x: 0, y: 6, w: 24, h: 12, minH: 12 },
    ],
    md: [
      { i: 'a', x: 0, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'b', x: 8, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'c', x: 16, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'd', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'e', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'f', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'g', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'h', x: 0, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'i', x: 8, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'j', x: 16, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'k', x: 0, y: 6, w: 24, h: 7, minH: 7 },
      { i: 'l', x: 0, y: 6, w: 24, h: 12, minH: 12 },
      { i: 'm', x: 0, y: 6, w: 24, h: 12, minH: 12 },
    ],
    sm: [
      { i: 'a', x: 0, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'b', x: 8, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'c', x: 16, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'd', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'e', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'f', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'g', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'h', x: 0, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'i', x: 8, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'j', x: 16, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'k', x: 0, y: 6, w: 24, h: 7, minH: 7 },
      { i: 'l', x: 0, y: 6, w: 24, h: 12, minH: 12 },
      { i: 'm', x: 0, y: 6, w: 24, h: 12, minH: 12 },
    ],
    xs: [
      { i: 'a', x: 0, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'b', x: 8, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'c', x: 16, y: 0, w: 8, h: 6, minH: 6 },
      { i: 'd', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'e', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'f', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'g', x: 0, y: 6, w: 16, h: 8, isResizable: false },
      { i: 'h', x: 0, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'i', x: 8, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'j', x: 16, y: 5, w: 8, h: 6, minH: 6 },
      { i: 'k', x: 0, y: 6, w: 24, h: 7, minH: 7 },
      { i: 'l', x: 0, y: 6, w: 24, h: 12, minH: 12 },
      { i: 'm', x: 0, y: 6, w: 24, h: 12, minH: 12 },
    ]
  },
  isFetching: true,
  error: null
}

type Action = 
  | UPDATE_DASHBOARD_GRID_TYPE
  | UPDATE_DASHBOARD_STATUS_TYPE

export default function gridReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case UPDATE_DASHBOARD_GRID: {
      const { layout } = action.payload
      return {
        ...state,
        isUpdated: true,
        layouts: {
          lg: [...layout],
          md: [...layout],
          sm: [...layout],
          xs: [...layout]
        }
      }
    }
    case UPDATE_DASHBOARD_STATUS: {
      const { isFetching, error } = action.payload
      return {
        ...state,
        isFetching,
        error
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/grid/index.js